import FullScreenError from "./FullScreenError";

export default FullScreenError;
